import { useLayoutEffect } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { WebView } from '@zenbusiness/application-commons-webview';

import { FloatingVeloButton } from '#client/components/FloatingVeloButton';
import { useAccountExperience } from '#client/hooks/useAccountExperience';

import * as Styled from './AppContainer.style';
import AppFooter from './components/AppFooter/AppFooter';
import AppHeader from './components/AppHeader/AppHeader';
import { BusinessEntityNav } from './components/BusinessEntityNav';
import { BusinessEntitySelector } from './components/BusinessEntitySelector';
import { useDrawerState } from './hooks/useDrawerState';

import OboBanner from '../OboBanner';

function AppContainer({ children }) {
  const { drawerState: isDrawerOpen } = useDrawerState();
  const { obo } = useAuthentication();
  const isObo = !!obo;
  const { accountExperience } = useAccountExperience();
  const { chrome } = accountExperience;

  useLayoutEffect(() => {
    const drawerOpenClass = 'drawer-open';

    if (isDrawerOpen) {
      document.body.classList.add(drawerOpenClass);
    } else {
      document.body.classList.remove(drawerOpenClass);
    }
  }, [isDrawerOpen]);

  return (
    <Styled.Site isWebView={WebView.isWebView}>
      {isObo && <OboBanner />}

      <Styled.Navigation canExpand={chrome.showBusinessEntityNavMenu} className="site-navigation" component="section">
        {!WebView.isWebView && <BusinessEntityNav />}
      </Styled.Navigation>

      <Styled.Content>
        {!WebView.isWebView && (
          <>
            <Styled.Header component="header" isObo={isObo}>
              <AppHeader />
            </Styled.Header>

            <Styled.Selector isObo={isObo}>
              <BusinessEntitySelector
                showAddNewBusiness={chrome.businessEntitySelector.showAddNewBusiness}
                showViewBusinesses={chrome.businessEntitySelector.showViewBusinesses}
              />
            </Styled.Selector>
          </>
        )}

        <Styled.Main component="main">{children}</Styled.Main>

        <Styled.Footer component="footer">
          <AppFooter />
        </Styled.Footer>
      </Styled.Content>

      {!WebView.isWebView && chrome.showVeloFloatingButton && <FloatingVeloButton />}
    </Styled.Site>
  );
}

export default AppContainer;
